import { OpsKb } from './OpsKb';

export const OpsKbPage = OpsKb;
export default OpsKb;
